import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'
import { DrawerView } from '@divvy-web/skylab.drawer'

import CollaboratorsList from '@sputnik/components/InviteCollaborators/CollaboratorsList'
import { InviteCollaboratorsDrawerProps } from '@sputnik/components/InviteCollaborators/types'

import styles from './InviteCollaboratorsDrawerView.module.scss'

export const InviteCollaboratorsDrawerView = ({
  appId,
  onInviteCollaborator,
  onDeleteCollaborator,
  onClose,
  icon,
}: InviteCollaboratorsDrawerProps) => {
  const [getClassName] = useNameFormatter('InviteCollaboratorsDrawerView')

  return (
    <DrawerView
      title={
        <FormattedMessage
          defaultMessage='Invite collaborators'
          id='sputnik.InviteCollaboratorsDrawerView__ni18Y2'
        />
      }
      {...(icon === 'back'
        ? {
            onBackClick: onClose,
          }
        : {
            onCloseClick: onClose,
          })}
    >
      <div className={styles[getClassName('')]}>
        <FormattedMessage
          defaultMessage='Collaborators have no limit. Admins are limited to 3. Both can help you fill out this application and set up your account.'
          id='sputnik.InviteCollaboratorsDrawerView__eRR18Q'
        />
        <CollaboratorsList
          appId={appId}
          onDeleteCollaborator={onDeleteCollaborator}
          onInviteCollaborator={onInviteCollaborator}
        />
      </div>
    </DrawerView>
  )
}

export default InviteCollaboratorsDrawerView
